'use client'

import classNames from 'classnames'
import dynamic from 'next/dynamic'
import { Suspense } from 'react'
import MapList from '../mapList'
import { useHouseListContext } from './context'
const MapView = dynamic(() => import('../mapView'), { ssr: false })
// const MapList = dynamic(() => import('../mapList'), { ssr: false })
const MapH1 = dynamic(() => import('../mapList/h1'), { ssr: false })

export default function MainLayoutContent({
  seoFilter,
  children
}) {

  const { showMap, mapHeihgt, mapwrapRef, fullMap, listLoading, rect } = useHouseListContext()
  return (
    <div id='house-wrap' className={classNames('flex-1 min-h-0 flex !mt-0', showMap ? 'lg:px-16' : 'page-wrap', { 'gap-x-20': showMap && !fullMap })}>
      <div className={classNames(
        'space-y-30',
        showMap ? 'w-2/5 min-w-[750px] pb-24 hidden xl:block transition-[width]' : 'w-full min-w-0',
        { '!w-0 overflow-hidden !min-w-0': fullMap }
      )}>
        {
          showMap
            ? (
              <>
                {
                  !listLoading && rect && (
                    <>
                      <Suspense>
                        <MapH1></MapH1>
                      </Suspense>
                      {children}
                    </>
                  )
                }
                <MapList></MapList>
                <div className='pb-100'>
                  {seoFilter}
                </div>
              </>
            )
            : children
        }
      </div>
      {
        showMap && (
          <div ref={mapwrapRef} className='bone flex-1 min-w-0 min-h-full'>
            {mapHeihgt ? <MapView></MapView> : undefined}
          </div>
        )
      }
    </div>
  )
}